module.exports = __webpack_public_path__ + "img/defaultTipsThumb.c98da906.png";